import { Loader2, Lightbulb } from "lucide-react";
import { Textarea } from "@/components/ui/textarea";

// The points MiLu must work into a reply, kept between visits.
export const ReplyNotes = ({ notes, onChange, ideas, busy, onSuggest, onUseIdea }) => (
  <div className="mt-3 rounded-2xl border border-white/10 bg-page p-4" data-testid="reply-notes">
    <div className="flex flex-wrap items-center gap-2">
      <p className="text-[11px] uppercase tracking-widest text-brand">What should MiLu mention?</p>
      <button
        data-testid="suggest-notes-button"
        onClick={onSuggest}
        disabled={busy}
        className="ms-auto inline-flex items-center gap-1.5 rounded-full border border-white/10 px-3 py-1.5 text-xs text-ink-soft transition-colors hover:border-brand/50 hover:text-brand"
      >
        {busy ? <Loader2 className="h-3.5 w-3.5 animate-spin" /> : <Lightbulb className="h-3.5 w-3.5" />}
        Suggest answers
      </button>
    </div>
    <Textarea
      data-testid="reply-notes-input"
      dir="auto"
      value={notes}
      rows={2}
      maxLength={1000}
      onChange={(e) => onChange(e.target.value)}
      placeholder="e.g. I can pay next Friday · I need two more weeks · ask them to call me"
      className="mt-2 min-h-[64px] w-full resize-y rounded-xl text-sm"
    />
    {ideas.length > 0 && (
      <div className="mt-2 flex flex-wrap gap-1.5" data-testid="note-ideas">
        {ideas.map((idea) => (
          <button
            key={idea}
            data-testid={`note-idea-${idea.slice(0, 14)}`}
            onClick={() => onUseIdea(idea)}
            title="Add this to my notes"
            dir="auto"
            className="rounded-full border border-brand/30 bg-brand/10 px-3 py-1.5 text-xs text-brand transition-colors hover:bg-brand/20"
          >
            {idea}
          </button>
        ))}
      </div>
    )}
    <p className="mt-1.5 text-xs text-ink-soft">
      These points go into every reply MiLu drafts, and stay here for next time.
      {notes.trim() && (
        <button
          data-testid="clear-notes-button"
          onClick={() => onChange("")}
          className="ms-2 underline decoration-dotted hover:text-ink"
        >
          Clear
        </button>
      )}
    </p>
  </div>
);
